import {useHeroTerrace} from "./useHeroTerrace";
import {GridTypes} from "../pages/MainGridPage";
import {useGridType} from "./useGridType";
import {useStores} from "../stores/useStores";
import {useShowHomepage} from "./useShowHomepage";

export function useShouldDisplayHero() {
    const isWelcomePage = useShowHomepage();
    const heroTerrace = useHeroTerrace();
    const currentOrgGridType = useGridType();
    const {interfaceStore} = useStores();
    return !!(currentOrgGridType === GridTypes.terraced && interfaceStore.isMainGrid && heroTerrace) || isWelcomePage;
}